import { ApiNumber, NumberKey } from 'types/models/ApiNumber';

export const getNumber = (numbers: ApiNumber[], key: NumberKey): string =>
  numbers.find((number) => number.key === key)?.value.replace(/\s/g, '\u00A0') || '';

export const getNumbers = (numbers: ApiNumber[], keys: NumberKey[]): string[] =>
  keys.map((key) => getNumber(numbers, key));
